export const rustApiPath = {
        GetDashboardAnalytics: 'GetDashboardAnalytics',
        GetReport: 'GetReport',
        GetApplicationHistoryEvent: 'GetApplicationHistoryEvent',
        GetWebHistoryEvent: 'GetWebHistoryEvent',
        GetSearchKeyEvent: 'GetSearchKeyEvent',
        GetFileEvent: 'GetFileEvent',
        GetMouseKeyboardEvent: 'GetMouseKeyboardEvent',
        GetDesktopDetailsEvent: 'GetDesktopDetailsEvent',
        GetDashboardOnlineUsers: 'GetDashboardOnlineUsers',
        IndividualReport: '/IndividualReport',
        IndividualOverviewReport: 'IndividualOverviewReport',
        GetContextSwitching: 'GetContextSwitching',
        GetMouseClickEvent: 'GetMouseClickEvent',
        GetErrorLogEvent: "GetErrorLogEvent",
        GetTopSupervisors: "GetTopSupervisors",
        GetEmployeeMeetingReports: "GetEmployeeMeetingReports",
        GetTopActiveEmployees: "GetTopActiveEmployees",
        AISummary: "AiSummary",
        TaskActivityChart: "TaskActivityChart",
        GetEmployeesByAccountId: "GetEmployeesByAccountId",
        DashboardDailyWorkforce: "DailyWorkforce",
        DashboardUsersAiActivity: "DashboardUsersAiActivity"

}


export type TRustApiPath = keyof typeof rustApiPath;